import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import { getSideContentStylesAsClassName } from './field-side-content-styles';
import { twMerge } from 'tailwind-merge';

export interface IFieldSideContentProps {
  /** When the side content is displayed on the right */
  align?: 'left' | 'right';
}

export type FieldSideContentProps =
  WithChildrenCommonProps<IFieldSideContentProps>;

export const FieldSideContent = React.forwardRef(
  (
    props: FieldSideContentProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ): JSX.Element => {
    const {
      children,
      className: classNameProp,
      align = 'left',
      ...rest
    } = props;
    const twClassName = twMerge(
      getSideContentStylesAsClassName(align),
      classNameProp
    );

    return (
      <div ref={ref} className={twClassName} {...rest}>
        {children}
      </div>
    );
  }
);

FieldSideContent.displayName = 'FieldSideContent';
